import React from "react";
import { Box, Grid, Skeleton } from "@mui/material";

const ArticleSkeleton = ({ isMediumScreen }) => {
  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
      }}
    >
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          m: isMediumScreen ? 3.5 : "15px",
          mt: 0,
          pt: 6,
          ml: isMediumScreen ? 3.5 : "38px",
          borderRadius: "12px",
          mb: 2,
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {/* Hero Image Skeleton */}
        <Skeleton
          variant="rectangular"
          width="100%"
          height={isMediumScreen ? 530 : 225}
          sx={{
            borderRadius: "12px",
            mb: 2,
            bgcolor: "rgba(255, 255, 255, 0.1)",
          }}
        />

        {/* News Title Skeleton */}
        <Box sx={{ mb: 4 }}>
          <Skeleton
            variant="text"
            width={120}
            height={40}
            sx={{ bgcolor: "rgba(255, 255, 255, 0.1)" }}
          />
        </Box>
        {Array.from({ length: 4 }).map((_, index) => (
          <Box sx={{ mb: 0 }} key={index}>
            <Skeleton
              variant="text"
              width={"100%"}
              height={60}
              sx={{ bgcolor: "rgba(255, 255, 255, 0.1)" }}
            />
          </Box>
        ))}

        {/* Tutorial Cards Grid Skeleton */}
      </Box>
      {/* Right side - fixed content */}
      {!isMediumScreen && (
        <Box
          sx={{
            width: { lg: 370, sm: 300 },
            p: 3,
            height: "auto",
            overflowY: "auto",
          }}
        >
          {/* UserProfile Skeleton */}
          <Box
            sx={{
              bgcolor: "rgba(255, 255, 255, 0.05)",
              mt: 3,
              p: 3,
              borderRadius: "16px",
            }}
          >
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}
            >
              <Skeleton
                variant="circular"
                width={57}
                height={57}
                sx={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
              />
              <Box>
                <Skeleton
                  variant="text"
                  width={120}
                  sx={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
                />
                <Skeleton
                  variant="text"
                  width={80}
                  sx={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
                />
              </Box>
            </Box>

            <Skeleton
              variant="rectangular"
              height={50}
              sx={{
                my: 2,
                borderRadius: "12px",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              }}
            />

            <Box sx={{ display: "flex", gap: 1, mb: 3 }}>
              <Skeleton
                variant="rectangular"
                width="50%"
                height={40}
                sx={{
                  borderRadius: "8px",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                }}
              />
              <Skeleton
                variant="rectangular"
                width="50%"
                height={40}
                sx={{
                  borderRadius: "8px",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                }}
              />
            </Box>

            <Skeleton
              variant="rectangular"
              width="100%"
              height={40}
              sx={{
                borderRadius: "8px",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              }}
            />
          </Box>

          {/* Chat Section Skeleton */}
          <Box mt={4}>
            <Box
              sx={{
                bgcolor: "rgba(255, 255, 255, 0.05)",
                borderRadius: "12px",
                pb: 3,
              }}
            >
              {/* Chat Header */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  background: "rgba(255, 255, 255, 0.07)",
                  borderTopRightRadius: "12px",
                  borderTopLeftRadius: "12px",
                  p: 1.5,
                  pl: 2.5,
                  pr: 2.5,
                  mb: 2,
                }}
              >
                <Box display="flex">
                  <Skeleton
                    variant="circular"
                    width={40}
                    height={40}
                    sx={{
                      mr: 1.5,
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                    }}
                  />
                  <Box>
                    <Skeleton
                      variant="text"
                      width={80}
                      sx={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
                    />
                    <Skeleton
                      variant="text"
                      width={100}
                      sx={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
                    />
                  </Box>
                </Box>
                <Skeleton
                  variant="circular"
                  width={40}
                  height={40}
                  sx={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
                />
              </Box>

              {/* Chat Message */}
              <Box mx={2.5}>
                <Skeleton
                  variant="rectangular"
                  width={220}
                  height={80}
                  sx={{
                    borderRadius: "12px",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    mb: 3,
                  }}
                />
              </Box>

              {/* Chat Input */}
              <Box mx={2.5}>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={40}
                  sx={{
                    borderRadius: "4px",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                  }}
                />
              </Box>
            </Box>
          </Box>

          {/* Match Finder Button Skeleton */}
          <Box display="flex" justifyContent="left" mt={4}>
            <Skeleton
              variant="rectangular"
              width={400}
              height={120}
              sx={{
                borderRadius: "12px",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              }}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ArticleSkeleton;
